import UikTableActions from "./Actions.vue"
import UikFilters from "./Filters.vue"
import UikTHead from "./Head.vue"
import UikPaginate from "./Paginate.vue"
import UikTRow from "./Row.vue"
import UikTable from "./Table.vue"
import UikTd from "./Td.vue"
import UikTh from "./Th.vue"

export default [
    UikTableActions,
    UikFilters,
    UikTHead,
    UikPaginate,
    UikTRow,
    UikTable,
    UikTd,
    UikTh
]
